import dayjs from "dayjs";

// Date formats for dayjs
export const YYYY = "YYYY";
export const MMM_YYYY = "MMM-YYYY";
export const MMM_YY = "MMM YY";
export const MMM_APOSTROPHE_YY = "MMM 'YY";
export const YYYY_MM_DD = "YYYY-MM-DD";
export const MM_DD_YYYY = "MM-DD-YYYY";
export const DISPLAY_DATE = "MMM DD, YYYY";
export const DD_MMM_YYYY_LT = "DD-MMM-YYYY | LT";
export const Q_YYYY = "Q-YYYY";
export const MM_SPACE_YYYY = "MMM YYYY";
export const MMM = "MMM";

// Date formats for date picker
export const TIME_FORMAT = "hh:mm A";
export const RANDOM_DATE_FOR_CHANNELS_LAST_MESSAGE = "2000-01-01T01:00:00.00Z";
export const FILTER_DATE_INPUT_FORMAT = "MMM dd, yyyy";
export const QUARTER_FORMAT = "QQQ-yyyy";
export const MONTH_FORMAT = "MMM-yyyy";
export const YEAR_FORMAT = "yyyy";
export const DISPLAY_DATE_HH_MM_A = "MMM DD, YYYY h:mmA";

export const LAST_YEAR = dayjs().subtract(1, "year").format(YYYY);

export const MMM_D = "MMM D";
